import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children, requiredRole }) {
  const { token } = useAuth();

  if (!token) {
    // No token, redirect to login
    return <Navigate to="/login" replace />;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch (error) {
    // Token is invalid
    console.error("Invalid JWT:", error);
    return <Navigate to="/login" replace />;
  }

  const { role, exp } = decoded;

  // Optional: check if token is expired
  if (exp && Date.now() >= exp * 1000) {
    console.warn("JWT expired");
    return <Navigate to="/login" replace />;
  }

  // Check role if required
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
